export function footprintMyListGet(page) {
	return {
    type: 'FOOTPRINT_MY_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export function footprintMyItemDel(pic) {
	return {
    type: 'FOOTPRINT_MY_ITEM_DEL',
		payload: {
			pic: pic,
		},
	}
}

export function footprintPartnerListGet(page) {
	return {
    type: 'FOOTPRINT_PARTNER_LIST_GET',
		payload: {
			page: page,
		},
	}
}


export function footprintPartnerItemDel(pic) {
	return {
    type: 'FOOTPRINT_PARTNER_ITEM_DEL',
		payload: {
			pic: pic,
		},
	}
}
